import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";

let config = null;

if (process.env.NODE_ENV !== "production") {
  config = {
    apiKey: "AIzaSyDmq7DMz1Q-sztTeaExYyqpqLWlxUERdxY",
    authDomain: "virtual-2ff48.firebaseapp.com",
    databaseURL: "https://virtual-2ff48.firebaseio.com",
    projectId: "virtual-2ff48",
    storageBucket: "virtual-2ff48.appspot.com",
    messagingSenderId: "37386612879",
    appId: "1:37386612879:web:ce9ca4e9a95f5f02"
  };
} else {
  config = {
    apiKey: "AIzaSyBfj6rz1RCXopOy8FjyYD-B6uWIbK6uiqI",
    authDomain: "virtual-48f9e.firebaseapp.com",
    databaseURL: "https://virtual-48f9e.firebaseio.com",
    projectId: "virtual-48f9e",
    messagingSenderId: "1068488493638",
    storageBucket: "gs://virtual-48f9e.appspot.com/"
  };
}

if (config !== null) {
  firebase.initializeApp(config);
}


const state = {
  db: null,
  storage: null,
  auth: null,
  projectID: config.projectId,
  errors: []
};

const mutations = {
  ADD_ERROR(state, error) {
    state.errors.push(error);
  },
  CLEAR_ERRORS(state) {
    state.errors = [];
  },
  SET_DATABASE(state) {
    if (state.db === null) {
      state.db = firebase.firestore();
    }

    if (state.auth === null) {
      state.auth = firebase.auth();
      console.log("moro authista");
    }

    if (state.storage === null) {
      state.storage = firebase.storage();
    }
  },
};

const actions = {
  clearErrors({ commit }) {
    commit("CLEAR_ERRORS");
  },
  sendError({ state, commit }, errorObject) {
    // If we've sent this error in the past, no need to send it again
    if (state.errors.find(e => e.error.message === errorObject.error.message)) return;

    commit("ADD_ERROR", errorObject);

    state.db.collection("errors").add(errorObject);
  }
};

export default {
  mutations,
  state,
  actions
}; 



// WEBPACK FOOTER //
// ./src/store/modules/Database.js